import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "./../index";
import { Button, Modal, Radio, Form } from "antd";
import Close from "./../../../assets/suc-khoe-vang/dateclose.png";
import Ivat from "./../../../assets/suc-khoe-vang/ivat.png";

const ModalQuestion = (props) => {
  const { ActionList, insuredPerson, indexEdit } = useContext(AuthContext);
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const [formData, setFormData] = useState({});
  const [disabled, setDisabled] = useState(null);
  const [disabledbtn, setDisabledbtn] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onFinish = useCallback(async () => {
    form
      .validateFields()
      .then((values) => {
        if (indexEdit !== null) {
          ActionList("edit", indexEdit, insuredPerson);
          props.handleCancel(true);
          return;
        }
        if (insuredPerson?.relationshipWithBuyerName === 1) {
          ActionList("unshift", "", insuredPerson);
          props.handleCancel(true);
        } else {
          ActionList("add", "", insuredPerson);
          props.handleCancel(true);
        }
      })
      .catch((errorfields) => {
        console.log(errorfields);
      });
  }, [form, indexEdit, insuredPerson, ActionList, props]);

  useEffect(() => {
    if (
      formData?.question1 === 2 ||
      formData?.question2 === 2 ||
      formData?.question3 === 2 ||
      formData?.question4 === 2 ||
      formData?.question5 === 2
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
    if (
      formData?.question1 === 1 &&
      formData?.question2 === 1 &&
      formData?.question3 === 1 &&
      formData?.question4 === 1 &&
      formData?.question5 === 1
    ) {
      setDisabledbtn(false);
    } else {
      setDisabledbtn(true);
    }
  }, [formData]);

  const onChangForm = ({ data, name }) => {
    setFormData({
      ...formData,
      [name]: data,
    });
  };

  return (
    <div style={{ fontSize: 14 }}>
      <Modal
        className="custom-modal-antd"
        style={css.modal}
        centered={true}
        footer={false}
        closable={false}
        open={props.open}
        onCancel={() => props.handleCancel(false)}
        maskStyle={{ background: "#000000", opacity: 0.8, maxHeight: "90vh" }}
      >
        <div style={css.divHeder}>
          <div style={{ width: "90%", textAlign: "center" }}>
            Câu hỏi thẩm định
          </div>
          <div>
            <img
              onClick={() => props.handleCancel(false)}
              src={Close}
              alt="Global Care"
              width={20}
            />
          </div>
        </div>
        <Form
          style={{ fontSize: 14, color: "#343A40" }}
          ref={formRef}
          form={form}
          onFinish={onFinish}
          name="question"
          scrollToFirstError
        >
          <div style={{ padding: 10 }}>
            <div
              style={{
                padding: 10,
                color: "#FB7800",
                background: "#FFF6EE",
                borderRadius: 4,
                display: "flex",
                alignItems: "flex-start ",
                fontSize: 12,
              }}
            >
              <img
                style={{ width: 18, marginRight: 10 }}
                src={Ivat}
                alt="Global Care"
              />
              <div>
                Để đảm bảo quyền lợi cho Người được bảo hiểm, bạn vui lòng đọc
                kĩ và tích Có hoặc Không nếu Người được bảo hiểm đã, đang mắc
                phải một trong các bệnh hoặc tình trạng dưới đây:
              </div>
            </div>
            <div
              style={{
                marginTop: 10,
                padding: 10,
                background: !disabled ? "#F5FCF5" : "#FEF2F2",
                borderRadius: 4,
              }}
            >
              {!disabled ? (
                <div style={{ fontSize: 14, marginTop: 10 }}>
                  Người được bảo hiểm{" "}
                  <span
                    style={{ fontWeight: 600, textTransform: "capitalize" }}
                  >
                    {insuredPerson?.insuredName}
                  </span>{" "}
                  có bị mắc một trong số các bệnh dưới đây không?
                </div>
              ) : (
                <div style={{ fontSize: 14, marginTop: 10 }}>
                  Rất tiếc, khách hàng{" "}
                  <span
                    style={{ fontWeight: 500, textTransform: "capitalize" }}
                  >
                    {insuredPerson?.insuredName}
                  </span>{" "}
                  chưa đủ điều kiệm tham gia gói bảo hiểm này!
                </div>
              )}
            </div>
            <div style={{ marginTop: 10 }}>
              1. Người được bảo hiểm đã mắc hay đang mắc phải bệnh tâm thần,
              thần kinh, bệnh phong không?
              <div style={{ marginTop: 5 }}>
                <b>“Bệnh tâm thần, thần kinh”</b> là một trong các bệnh hoặc
                tình trạng sau: Parkinson, Alzheimer, Bệnh tế bào thần kinh vận
                động, Xơ cứng rải rác, Đa xơ cứng, Loạn dưỡng cơ, Nhược cơ, Động
                kinh, Não úng thủy, Bại não, Hội chứng liệt, Tâm thần phân liệt,
                Rối loạn loại phân liệt, Rối loạn hoang tưởng, Rối loạn tâm
                thần, Sa sút trí tuệ, Thiểu năng trí tuệ, Hội chứng Down”
              </div>
            </div>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn thông tin"
                },
                {
                  message: 'Bạn chưa đủ điều kiện tham gia bảo hiểm.',
                  pattern: /[0-1]/
                }
              ]}
              name="question1"
              style={css.FormItemsHolder}
            >
              <Radio.Group
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "question1" });
                }}
              >
                <Radio value={1}>Không</Radio>
                <Radio value={2}>Có</Radio>
              </Radio.Group>
            </Form.Item>
            <div style={{ marginTop: 10 }}>
              2. Người được bảo hiểm đã mắc hay đang mắc phải “bệnh lý nghiêm
              trọng” không?
              <div style={{ marginTop: 5 }}>
                <b>“Bệnh lý nghiêm trọng”</b> là một trong các bệnh hoặc tình
                trạng sau:
                <ul style={{ paddingLeft: 25 }}>
                  <li>Phẫu thuật não;</li>
                  <li>Đột quỵ, Xuất huyết não, Xơ cứng động mạch;</li>
                  <li>
                    Bệnh phổi tắc nghẽn mãn tính (COPD), Phẫu thuật cắt bỏ một
                    bên phổi, Tâm phế mạn;
                  </li>
                  <li>
                    Nhồi máu cơ tim; Phẫu thuật động mạch chủ, Phẫu thuật van
                    tim, Ghép tim;
                  </li>
                  <li>
                    Xơ gan mất bù, Suy gan, Suy thận giai đoạn cuối, Nang ở tủy
                    thận;
                  </li>
                  <li>Ghép tủy xương, Suy tủy xương;</li>
                  <li>Đang trong tình trạng hôn mê hoặc sống thực vật.</li>
                </ul>
              </div>
            </div>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn thông tin"
                },
                {
                  message: 'Bạn chưa đủ điều kiện tham gia bảo hiểm.',
                  pattern: /[0-1]/
                }
              ]}
              name="question2"
              style={css.FormItemsHolder}
            >
              <Radio.Group
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "question2" });
                }}
              >
                <Radio value={1}>Không</Radio>
                <Radio value={2}>Có</Radio>
              </Radio.Group>
            </Form.Item>
            <div style={{ marginTop: 10 }}>
              3. Người được bảo hiểm đã, đang trong tình trạng thương tật vĩnh
              viễn trên 50% không?
              <div style={{ marginTop: 5 }}>
                <b>“Thương tật vĩnh viễn trên 50%”</b> là tình trạng Người được
                bảo hiểm bị mất một phần cơ thể hoặc thương tật sau khi điều trị
                vẫn kéo dài từ 12 tháng liên tục trở lên. Các thương tật này cản
                trở hoàn toàn Người được bảo hiểm thực hiện bất kỳ công việc nào
                của mình, không có khả năng phục hồi và có tỷ lệ trên 50%.
              </div>
            </div>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn thông tin"
                },
                {
                  message: 'Bạn chưa đủ điều kiện tham gia bảo hiểm.',
                  pattern: /[0-1]/
                }
              ]}
              name="question3"
              style={css.FormItemsHolder}
            >
              <Radio.Group
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "question3" });
                }}
              >
                <Radio value={1}>Không</Radio>
                <Radio value={2}>Có</Radio>
              </Radio.Group>
            </Form.Item>
            <div style={{ marginTop: 10 }}>
            

              4. Người được bảo hiểm có đang trong thời gian điều trị nội trú do bệnh hoặc tai nạn không?
              <div style={{ marginTop: 5 }}>
                <b>“Điều trị nội trú”</b> là việc Người được bảo hiểm nhập viện và lưu viện từ 24 giờ trở lên để phẫu thuật hoặc điều trị.
.
              </div>
            </div>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn thông tin",
                },
                {
                  message: 'Bạn chưa đủ điều kiện tham gia bảo hiểm.',
                  pattern: /[0-1]/
                }
              ]}
              name="question4"
              style={css.FormItemsHolder}
            >
              <Radio.Group
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "question4" });
                }}
              >
                <Radio value={1}>Không</Radio>
                <Radio value={2}>Có</Radio>
              </Radio.Group>
            </Form.Item>
            <div style={{ marginTop: 10 }}>
              5. Người được bảo hiểm đã mắc hay đang mắc phải bệnh ung thư không?
            </div>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn thông tin",
                },
                {
                  message: 'Bạn chưa đủ điều kiện tham gia bảo hiểm.',
                  pattern: /[0-1]/
                }
              ]}
              name="question5"
              style={css.FormItemsHolder}
            >
              <Radio.Group
                onChange={(e) => {
                  onChangForm({ data: e.target.value, name: "question5" });
                }}
              >
                <Radio value={1}>Không</Radio>
                <Radio value={2}>Có</Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          <div style={css.boxbtn}>
            {/* <Button
              onClick={() => props.handleCancel()}
              style={css.btnBack}
              type="#009B4B"
            >
              Quay lại
            </Button> */}
            <Button
              // disabled={disabledbtn}
              htmlType="submit"
              style={ css.btnNext}
              type="#009B4B"
            >
              Tiếp tục
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

const css = {
  divHeder: {
    borderBottom: "1px solid #dddddd",
    fontWeight: 500,
    fontSize: 16,
    padding: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    backgroundColor: "#FFF",
    borderRadius: "15px 15px 0px 0px",
    zIndex: 1
  },
  modal: {
    maxWidth: "100%",
    margin: 0,
    verticalAlign: "bottom",
    padding: 0,
    maxHeight: "95%",
  },
  FormItemsHolder: {
    width: "100%",
    borderRadius: 8,
    margin: "5px 0px",
    padding: 0,
    margin: 0,
  },
  boxbtn: {
    display: "flex",
    justifyContent: "space-between",
    position: "sticky",
    bottom: 0,
    height: 76,
    background: "#fff",
    borderRadius: "16px 16px 0px 0px",
    display: "flex",
    alignItems: "center",
    boxShadow: "0px -4px 8px 0px #0000001A",
    padding: "0px 10px",
  },
  btnBack: {
    color: "#009B4B",
    background: "#FFF",
    fontWeight: "bold",
    width: "48%",
    height: "44px",
    borderRadius: 8,
    border: "1px solid #009B4B",
  },
  btnNext: {
    color: "#FFF",
    background: "#009B4B",
    fontWeight: "bold",
    width: "100%",
    height: "44px",
    borderRadius: 8,
  },
  btnDisa: {
    color: "#C4CFC9",
    background: "#EBF0ED",
    fontWeight: "bold",
    width: "100%",
    height: "44px",
    borderRadius: 8,
  },
};

export default ModalQuestion;
